import { Platform } from 'react-native';

// Import images for web (Vite handles these as URLs)
import logoImg from '@/assets/logo.png';

// Helper to get image source compatible with both platforms
export const getImageSource = (webImage: string) => {
  if (Platform.OS === 'web') {
    return { uri: webImage };
  }
  return webImage as any;
};

// Export commonly used images
export const logo = getImageSource(logoImg);





